// @flow
import mean from 'lodash/mean';
import type { FlashCard } from '../../flip/types';
import type { SessionMeta } from '../../types';
import {
  calcTimeFactor,
  getExpectedTimeFlip,
  getNewScoreFlip,
  getScorePenalty,
  normalizeScore,
} from './utils';

// Calculates the new score for flashcards
const calcScore = (
  card: FlashCard,
  previousScore: *,
  confidence: number,
  // The user starts their "thinking" as soon as the card is shown, which is before the flip
  // The time taken ends once the answer/confidence is submitted
  timeTaken: number,
  sessionMeta: SessionMeta,
) => {
  // Gets the "fastest" expected time to answer the item
  const timeExpected = getExpectedTimeFlip(card);

  // Provides a factor (0-1) whether the user's answer was fast or slow
  // Speed is another way to estimate how confident a user is
  const timeFactor = calcTimeFactor(timeTaken, timeExpected / 1000);

  const currentScore = mean(card.cardBack.map(item => {
    if (item.currentScore) {
      return item.currentScore.value;
    }
    return 0;
  }));

  const newScore = getNewScoreFlip({
    confidence,
    currentScore,
    timeFactor,
  });

  const itemsMeta = sessionMeta[card.itemId];

  const scorePenalty = itemsMeta
    ? getScorePenalty(
      confidence === 100,
      itemsMeta.numSuccessAttempts,
      itemsMeta.numTotalAttempts,
      (new Date().valueOf() - new Date(itemsMeta.lastTime).valueOf()) / 1000,
    )
    : 0;
  const updatedScore = normalizeScore(newScore - scorePenalty);

  return {
    score: updatedScore,
    timeFactor,
  };
};

export default calcScore;
